import {
  Request
} from '../index'

/** 获取城市下的酒店筛选条件 */
export function kpiHotelGetHotelFilterList(data = {}) {
  return Request('newhotel/hotel/getHotelFilterListV2', 'post', undefined, data)
}

/** 获取关键字查询结果 */
export function kpiHotelGetHotelSearchEngine(data = {}) {
  return Request('newhotel/hotel/getHotelSearchEngineV3', 'post', undefined, data)
}

/** 预订成功页酒店推荐 */
export function kpiHotelRecommendhotels(data = {}) {
  return Request('hotel/recommendhotels', 'post', undefined, data, false, true)
}
